import { put, call, delay } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadHostTypeListFailed,
  loadHostTypeListSuccessful,
  loadHostTypeListBegin,
} from '../actions';

export default function* loadHostTypeList(action) {
  try {
    const url = `${BACKEND_URL}/host-types`;
    yield put(loadHostTypeListBegin());
    const dataResponse = yield makeRequest(url, {}, {}, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      data.result = data.data;
      yield put(loadHostTypeListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadHostTypeListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadHostTypeListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
